import { NoiseCatalogNumbersList } from "./noiseCatalogNumbersList";
import { ResultStatus } from "./resultStatus";

export class FindAllNoiseCatalogNumberListResponse {
    noiseCatalogNumbersList?: NoiseCatalogNumbersList[];
    status: ResultStatus;
}